import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import { createPortal } from "react-dom";

import { db } from "../firebase";

import {
  collection,
  getDocs,
  doc,
  updateDoc,
  query,
  where,
  increment,
  runTransaction,
} from "firebase/firestore";

import { useBalance } from "../context/BalanceContext";
import "./BetTrade.css";

// ============================================================
// BETSLIP
// ============================================================
const LANGUAGE_TRANSLATIONS = {
  en: {
    noProcessingBets: "No Processing bets",
    stake: "Stake",
    expectedProfit: "Expected Profit",
    betId: "Bet ID",
    bettingTime: "Betting Time",
    cancel: "Cancel",
    cancelBet: "Are you sure you want to cancel this bet?",
    cancelSuccess: "Bet cancelled successfully",
    cancelError: "Failed to cancel bet",
    loading: "Loading...",
    error: "An error occurred",
    success: "Success",
    failed: "Failed",
    save: "Save",
    close: "Close",
    back: "Back",
    confirm: "Confirm",
    totalOdds: "Total Odds",
    potentialWin: "Potential Win",
    status: "Status",
    pending: "Pending",
    won: "Won",
    lost: "Lost",
    cancelled: "Cancelled",
    processing: "Processing"
  },

  sw: {
    noProcessingBets: "Hakuna bet zinazoendelea",
    stake: "Kiasi cha dau",
    expectedProfit: "Faida inayotarajiwa",
    betId: "Namba ya dau",
    bettingTime: "Muda wa kuweka dau",
    cancel: "Ghairi",
    cancelBet: "Una uhakika unataka kughairi dau hili?",
    cancelSuccess: "Dau limeghairiwa kikamilifu",
    cancelError: "Imeshindwa kughairi dau",
    loading: "Inapakia...",
    error: "Hitilafu imetokea",
    success: "Imefanikiwa",
    failed: "Imeshindwa",
    save: "Hifadhi",
    close: "Funga",
    back: "Rudi",
    confirm: "Thibitisha",
    totalOdds: "Odds jumla",
    potentialWin: "Ushindi unaowezekana",
    status: "Hali",
    pending: "Inasubiri",
    won: "Imeshinda",
    lost: "Imepoteza",
    cancelled: "Imeghairiwa",
    processing: "Inaendelea"
  },

  pt: {
    noProcessingBets: "Nenhuma aposta em processamento",
    stake: "Valor da aposta",
    expectedProfit: "Lucro esperado",
    betId: "ID da aposta",
    bettingTime: "Hora da aposta",
    cancel: "Cancelar",
    cancelBet: "Tem a certeza de que deseja cancelar esta aposta?",
    cancelSuccess: "Aposta cancelada com sucesso",
    cancelError: "Falha ao cancelar a aposta",
    loading: "A carregar...",
    error: "Ocorreu um erro",
    success: "Sucesso",
    failed: "Falhou",
    save: "Guardar",
    close: "Fechar",
    back: "Voltar",
    confirm: "Confirmar",
    totalOdds: "Odds totais",
    potentialWin: "Ganho potencial",
    status: "Estado",
    pending: "Pendente",
    won: "Ganha",
    lost: "Perdida",
    cancelled: "Cancelada",
    processing: "Em processamento"
  },

  "pt-AO": {
    noProcessingBets: "Não há apostas em processamento",
    stake: "Valor da aposta",
    expectedProfit: "Lucro esperado",
    betId: "ID da aposta",
    bettingTime: "Hora da aposta",
    cancel: "Cancelar",
    cancelBet: "Tem a certeza de que deseja cancelar esta aposta?",
    cancelSuccess: "Aposta cancelada com sucesso",
    cancelError: "Não foi possível cancelar a aposta",
    loading: "A carregar...",
    error: "Ocorreu um erro",
    success: "Sucesso",
    failed: "Falhou",
    save: "Guardar",
    close: "Fechar",
    back: "Voltar",
    confirm: "Confirmar",
    totalOdds: "Odds totais",
    potentialWin: "Ganho potencial",
    status: "Estado",
    pending: "Pendente",
    won: "Ganha",
    lost: "Perdida",
    cancelled: "Cancelada",
    processing: "Em processamento"
  },

  fr: {
    noProcessingBets: "Aucun pari en cours de traitement",
    stake: "Mise",
    expectedProfit: "Bénéfice attendu",
    betId: "ID du pari",
    bettingTime: "Heure du pari",
    cancel: "Annuler",
    cancelBet: "Voulez-vous vraiment annuler ce pari ?",
    cancelSuccess: "Pari annulé avec succès",
    cancelError: "Échec de l’annulation du pari",
    loading: "Chargement...",
    error: "Une erreur est survenue",
    success: "Succès",
    failed: "Échec",
    save: "Enregistrer",
    close: "Fermer",
    back: "Retour",
    confirm: "Confirmer",
    totalOdds: "Cote totale",
    potentialWin: "Gain potentiel",
    status: "Statut",
    pending: "En attente",
    won: "Gagné",
    lost: "Perdu",
    cancelled: "Annulé",
    processing: "En cours"
  },

  es: {
    noProcessingBets: "No hay apuestas en proceso",
    stake: "Importe de la apuesta",
    expectedProfit: "Beneficio esperado",
    betId: "ID de apuesta",
    bettingTime: "Hora de la apuesta",
    cancel: "Cancelar",
    cancelBet: "¿Seguro que quieres cancelar esta apuesta?",
    cancelSuccess: "Apuesta cancelada correctamente",
    cancelError: "No se pudo cancelar la apuesta",
    loading: "Cargando...",
    error: "Se ha producido un error",
    success: "Éxito",
    failed: "Error",
    save: "Guardar",
    close: "Cerrar",
    back: "Volver",
    confirm: "Confirmar",
    totalOdds: "Cuota total",
    potentialWin: "Ganancia potencial",
    status: "Estado",
    pending: "Pendiente",
    won: "Ganada",
    lost: "Perdida",
    cancelled: "Cancelada",
    processing: "En proceso"
  },

  ar: {
    noProcessingBets: "لا توجد رهانات قيد المعالجة",
    stake: "مبلغ الرهان",
    expectedProfit: "الربح المتوقع",
    betId: "رقم الرهان",
    bettingTime: "وقت الرهان",
    cancel: "إلغاء",
    cancelBet: "هل أنت متأكد أنك تريد إلغاء هذا الرهان؟",
    cancelSuccess: "تم إلغاء الرهان بنجاح",
    cancelError: "تعذر إلغاء الرهان",
    loading: "جارٍ التحميل...",
    error: "حدث خطأ",
    success: "نجاح",
    failed: "فشل",
    save: "حفظ",
    close: "إغلاق",
    back: "رجوع",
    confirm: "تأكيد",
    totalOdds: "إجمالي الاحتمالات",
    potentialWin: "الربح المحتمل",
    status: "الحالة",
    pending: "قيد الانتظار",
    won: "فائز",
    lost: "خاسر",
    cancelled: "ملغى",
    processing: "قيد المعالجة"
  },

  zh: {
    noProcessingBets: "没有正在处理的投注",
    stake: "投注金额",
    expectedProfit: "预期利润",
    betId: "投注编号",
    bettingTime: "投注时间",
    cancel: "取消",
    cancelBet: "确定要取消这笔投注吗？",
    cancelSuccess: "投注已成功取消",
    cancelError: "取消投注失败",
    loading: "正在加载...",
    error: "发生错误",
    success: "成功",
    failed: "失败",
    save: "保存",
    close: "关闭",
    back: "返回",
    confirm: "确认",
    totalOdds: "总赔率",
    potentialWin: "潜在奖金",
    status: "状态",
    pending: "待处理",
    won: "已赢",
    lost: "已输",
    cancelled: "已取消",
    processing: "处理中"
  },

  hi: {
    noProcessingBets: "कोई बेट प्रोसेस नहीं हो रही है",
    stake: "दांव की राशि",
    expectedProfit: "अपेक्षित लाभ",
    betId: "बेट आईडी",
    bettingTime: "बेट लगाने का समय",
    cancel: "रद्द करें",
    cancelBet: "क्या आप वाकई इस बेट को रद्द करना चाहते हैं?",
    cancelSuccess: "बेट सफलतापूर्वक रद्द हुई",
    cancelError: "बेट रद्द नहीं हो सकी",
    loading: "लोड हो रहा है...",
    error: "एक त्रुटि हुई",
    success: "सफलता",
    failed: "विफल",
    save: "सहेजें",
    close: "बंद करें",
    back: "वापस",
    confirm: "पुष्टि करें",
    totalOdds: "कुल ऑड्स",
    potentialWin: "संभावित जीत",
    status: "स्थिति",
    pending: "लंबित",
    won: "जीत",
    lost: "हार",
    cancelled: "रद्द",
    processing: "प्रोसेस हो रहा है"
  },

  bn: {
    noProcessingBets: "কোনো বাজি প্রক্রিয়াধীন নেই",
    stake: "বাজির পরিমাণ",
    expectedProfit: "প্রত্যাশিত লাভ",
    betId: "বাজির আইডি",
    bettingTime: "বাজি ধরার সময়",
    cancel: "বাতিল",
    cancelBet: "আপনি কি নিশ্চিত যে এই বাজিটি বাতিল করতে চান?",
    cancelSuccess: "বাজি সফলভাবে বাতিল হয়েছে",
    cancelError: "বাজি বাতিল করা যায়নি",
    loading: "লোড হচ্ছে...",
    error: "একটি ত্রুটি ঘটেছে",
    success: "সফল",
    failed: "ব্যর্থ",
    save: "সংরক্ষণ",
    close: "বন্ধ",
    back: "ফিরে যান",
    confirm: "নিশ্চিত করুন",
    totalOdds: "মোট অডস",
    potentialWin: "সম্ভাব্য জয়",
    status: "অবস্থা",
    pending: "অপেক্ষমাণ",
    won: "জিতেছেন",
    lost: "হেরেছেন",
    cancelled: "বাতিল হয়েছে",
    processing: "প্রক্রিয়াধীন"
  },

  ru: {
    noProcessingBets: "Нет ставок в обработке",
    stake: "Сумма ставки",
    expectedProfit: "Ожидаемая прибыль",
    betId: "ID ставки",
    bettingTime: "Время ставки",
    cancel: "Отменить",
    cancelBet: "Вы уверены, что хотите отменить эту ставку?",
    cancelSuccess: "Ставка успешно отменена",
    cancelError: "Не удалось отменить ставку",
    loading: "Загрузка...",
    error: "Произошла ошибка",
    success: "Успешно",
    failed: "Не удалось",
    save: "Сохранить",
    close: "Закрыть",
    back: "Назад",
    confirm: "Подтвердить",
    totalOdds: "Общий коэффициент",
    potentialWin: "Возможный выигрыш",
    status: "Статус",
    pending: "Ожидает",
    won: "Выигрыш",
    lost: "Проигрыш",
    cancelled: "Отменено",
    processing: "Обработка"
  },

  de: {
    noProcessingBets: "Keine Wetten in Bearbeitung",
    stake: "Einsatz",
    expectedProfit: "Erwarteter Gewinn",
    betId: "Wett-ID",
    bettingTime: "Wettzeit",
    cancel: "Abbrechen",
    cancelBet: "Möchtest du diese Wette wirklich stornieren?",
    cancelSuccess: "Wette erfolgreich storniert",
    cancelError: "Wette konnte nicht storniert werden",
    loading: "Wird geladen...",
    error: "Ein Fehler ist aufgetreten",
    success: "Erfolgreich",
    failed: "Fehlgeschlagen",
    save: "Speichern",
    close: "Schließen",
    back: "Zurück",
    confirm: "Bestätigen",
    totalOdds: "Gesamtquote",
    potentialWin: "Möglicher Gewinn",
    status: "Status",
    pending: "Ausstehend",
    won: "Gewonnen",
    lost: "Verloren",
    cancelled: "Storniert",
    processing: "In Bearbeitung"
  },

  it: {
    noProcessingBets: "Nessuna scommessa in elaborazione",
    stake: "Importo della puntata",
    expectedProfit: "Profitto previsto",
    betId: "ID scommessa",
    bettingTime: "Ora della scommessa",
    cancel: "Annulla",
    cancelBet: "Vuoi davvero annullare questa scommessa?",
    cancelSuccess: "Scommessa annullata con successo",
    cancelError: "Impossibile annullare la scommessa",
    loading: "Caricamento...",
    error: "Si è verificato un errore",
    success: "Successo",
    failed: "Non riuscito",
    save: "Salva",
    close: "Chiudi",
    back: "Indietro",
    confirm: "Conferma",
    totalOdds: "Quota totale",
    potentialWin: "Vincita potenziale",
    status: "Stato",
    pending: "In attesa",
    won: "Vinta",
    lost: "Persa",
    cancelled: "Annullata",
    processing: "In elaborazione"
  },

  nl: {
    noProcessingBets: "Geen weddenschappen in behandeling",
    stake: "Inzet",
    expectedProfit: "Verwachte winst",
    betId: "Wed-ID",
    bettingTime: "Tijdstip van de weddenschap",
    cancel: "Annuleren",
    cancelBet: "Weet je zeker dat je deze weddenschap wilt annuleren?",
    cancelSuccess: "Weddenschap succesvol geannuleerd",
    cancelError: "Weddenschap annuleren mislukt",
    loading: "Laden...",
    error: "Er is een fout opgetreden",
    success: "Geslaagd",
    failed: "Mislukt",
    save: "Opslaan",
    close: "Sluiten",
    back: "Terug",
    confirm: "Bevestigen",
    totalOdds: "Totale odds",
    potentialWin: "Mogelijke winst",
    status: "Status",
    pending: "In afwachting",
    won: "Gewonnen",
    lost: "Verloren",
    cancelled: "Geannuleerd",
    processing: "In behandeling"
  },

  tr: {
    noProcessingBets: "İşlemde olan bahis yok",
    stake: "Bahis miktarı",
    expectedProfit: "Beklenen kâr",
    betId: "Bahis kimliği",
    bettingTime: "Bahis zamanı",
    cancel: "İptal et",
    cancelBet: "Bu bahsi iptal etmek istediğinizden emin misiniz?",
    cancelSuccess: "Bahis başarıyla iptal edildi",
    cancelError: "Bahis iptal edilemedi",
    loading: "Yükleniyor...",
    error: "Bir hata oluştu",
    success: "Başarılı",
    failed: "Başarısız",
    save: "Kaydet",
    close: "Kapat",
    back: "Geri",
    confirm: "Onayla",
    totalOdds: "Toplam oran",
    potentialWin: "Olası kazanç",
    status: "Durum",
    pending: "Beklemede",
    won: "Kazandı",
    lost: "Kaybetti",
    cancelled: "İptal edildi",
    processing: "İşleniyor"
  },

  ja: {
    noProcessingBets: "処理中のベットはありません",
    stake: "賭け金",
    expectedProfit: "予想利益",
    betId: "ベットID",
    bettingTime: "ベット時刻",
    cancel: "キャンセル",
    cancelBet: "このベットをキャンセルしてもよろしいですか？",
    cancelSuccess: "ベットをキャンセルしました",
    cancelError: "ベットをキャンセルできませんでした",
    loading: "読み込み中...",
    error: "エラーが発生しました",
    success: "成功",
    failed: "失敗",
    save: "保存",
    close: "閉じる",
    back: "戻る",
    confirm: "確認",
    totalOdds: "合計オッズ",
    potentialWin: "予想賞金",
    status: "ステータス",
    pending: "保留中",
    won: "勝ち",
    lost: "負け",
    cancelled: "キャンセル済み",
    processing: "処理中"
  },

  ko: {
    noProcessingBets: "처리 중인 베팅이 없습니다",
    stake: "베팅 금액",
    expectedProfit: "예상 수익",
    betId: "베팅 ID",
    bettingTime: "베팅 시간",
    cancel: "취소",
    cancelBet: "이 베팅을 취소하시겠습니까?",
    cancelSuccess: "베팅이 성공적으로 취소되었습니다",
    cancelError: "베팅을 취소하지 못했습니다",
    loading: "로딩 중...",
    error: "오류가 발생했습니다",
    success: "성공",
    failed: "실패",
    save: "저장",
    close: "닫기",
    back: "뒤로",
    confirm: "확인",
    totalOdds: "총 배당률",
    potentialWin: "예상 당첨금",
    status: "상태",
    pending: "대기 중",
    won: "승리",
    lost: "패배",
    cancelled: "취소됨",
    processing: "처리 중"
  },

  vi: {
    noProcessingBets: "Không có cược nào đang xử lý",
    stake: "Tiền cược",
    expectedProfit: "Lợi nhuận dự kiến",
    betId: "Mã cược",
    bettingTime: "Thời gian đặt cược",
    cancel: "Hủy",
    cancelBet: "Bạn có chắc chắn muốn hủy cược này không?",
    cancelSuccess: "Đã hủy cược thành công",
    cancelError: "Không thể hủy cược",
    loading: "Đang tải...",
    error: "Đã xảy ra lỗi",
    success: "Thành công",
    failed: "Thất bại",
    save: "Lưu",
    close: "Đóng",
    back: "Quay lại",
    confirm: "Xác nhận",
    totalOdds: "Tổng tỷ lệ cược",
    potentialWin: "Tiền thắng tiềm năng",
    status: "Trạng thái",
    pending: "Đang chờ",
    won: "Thắng",
    lost: "Thua",
    cancelled: "Đã hủy",
    processing: "Đang xử lý"
  },

  th: {
    noProcessingBets: "ไม่มีเดิมพันที่กำลังดำเนินการ",
    stake: "จำนวนเงินเดิมพัน",
    expectedProfit: "กำไรที่คาดหวัง",
    betId: "รหัสเดิมพัน",
    bettingTime: "เวลาเดิมพัน",
    cancel: "ยกเลิก",
    cancelBet: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกเดิมพันนี้?",
    cancelSuccess: "ยกเลิกเดิมพันสำเร็จ",
    cancelError: "ไม่สามารถยกเลิกเดิมพันได้",
    loading: "กำลังโหลด...",
    error: "เกิดข้อผิดพลาด",
    success: "สำเร็จ",
    failed: "ล้มเหลว",
    save: "บันทึก",
    close: "ปิด",
    back: "กลับ",
    confirm: "ยืนยัน",
    totalOdds: "อัตราต่อรองรวม",
    potentialWin: "เงินรางวัลที่อาจได้รับ",
    status: "สถานะ",
    pending: "รอดำเนินการ",
    won: "ชนะ",
    lost: "แพ้",
    cancelled: "ยกเลิกแล้ว",
    processing: "กำลังดำเนินการ"
  },

  id: {
    noProcessingBets: "Tidak ada taruhan yang sedang diproses",
    stake: "Jumlah taruhan",
    expectedProfit: "Keuntungan yang diharapkan",
    betId: "ID taruhan",
    bettingTime: "Waktu taruhan",
    cancel: "Batalkan",
    cancelBet: "Apakah Anda yakin ingin membatalkan taruhan ini?",
    cancelSuccess: "Taruhan berhasil dibatalkan",
    cancelError: "Gagal membatalkan taruhan",
    loading: "Memuat...",
    error: "Terjadi kesalahan",
    success: "Berhasil",
    failed: "Gagal",
    save: "Simpan",
    close: "Tutup",
    back: "Kembali",
    confirm: "Konfirmasi",
    totalOdds: "Total odds",
    potentialWin: "Potensi kemenangan",
    status: "Status",
    pending: "Menunggu",
    won: "Menang",
    lost: "Kalah",
    cancelled: "Dibatalkan",
    processing: "Sedang diproses"
  },

  ms: {
    noProcessingBets: "Tiada pertaruhan sedang diproses",
    stake: "Jumlah pertaruhan",
    expectedProfit: "Keuntungan dijangka",
    betId: "ID pertaruhan",
    bettingTime: "Masa pertaruhan",
    cancel: "Batal",
    cancelBet: "Adakah anda pasti mahu membatalkan pertaruhan ini?",
    cancelSuccess: "Pertaruhan berjaya dibatalkan",
    cancelError: "Pertaruhan gagal dibatalkan",
    loading: "Sedang memuatkan...",
    error: "Ralat telah berlaku",
    success: "Berjaya",
    failed: "Gagal",
    save: "Simpan",
    close: "Tutup",
    back: "Kembali",
    confirm: "Sahkan",
    totalOdds: "Jumlah odds",
    potentialWin: "Potensi kemenangan",
    status: "Status",
    pending: "Menunggu",
    won: "Menang",
    lost: "Kalah",
    cancelled: "Dibatalkan",
    processing: "Sedang diproses"
  },

  ur: {
    noProcessingBets: "کوئی شرط زیرِ کارروائی نہیں ہے",
    stake: "شرط کی رقم",
    expectedProfit: "متوقع منافع",
    betId: "شرط کی شناخت",
    bettingTime: "شرط لگانے کا وقت",
    cancel: "منسوخ کریں",
    cancelBet: "کیا آپ واقعی یہ شرط منسوخ کرنا چاہتے ہیں؟",
    cancelSuccess: "شرط کامیابی سے منسوخ ہوگئی",
    cancelError: "شرط منسوخ نہیں ہوسکی",
    loading: "لوڈ ہو رہا ہے...",
    error: "ایک خرابی پیش آگئی",
    success: "کامیابی",
    failed: "ناکام",
    save: "محفوظ کریں",
    close: "بند کریں",
    back: "واپس",
    confirm: "تصدیق کریں",
    totalOdds: "کل اوڈز",
    potentialWin: "ممکنہ جیت",
    status: "حالت",
    pending: "زیرِ انتظار",
    won: "جیت",
    lost: "ہار",
    cancelled: "منسوخ",
    processing: "زیرِ کارروائی"
  },

  fa: {
    noProcessingBets: "هیچ شرطی در حال پردازش نیست",
    stake: "مبلغ شرط",
    expectedProfit: "سود مورد انتظار",
    betId: "شناسه شرط",
    bettingTime: "زمان ثبت شرط",
    cancel: "لغو",
    cancelBet: "آیا مطمئن هستید که می‌خواهید این شرط را لغو کنید؟",
    cancelSuccess: "شرط با موفقیت لغو شد",
    cancelError: "لغو شرط ناموفق بود",
    loading: "در حال بارگذاری...",
    error: "خطایی رخ داد",
    success: "موفقیت",
    failed: "ناموفق",
    save: "ذخیره",
    close: "بستن",
    back: "بازگشت",
    confirm: "تأیید",
    totalOdds: "ضریب کل",
    potentialWin: "برد احتمالی",
    status: "وضعیت",
    pending: "در انتظار",
    won: "برنده",
    lost: "بازنده",
    cancelled: "لغوشده",
    processing: "در حال پردازش"
  },

  ha: {
    noProcessingBets: "Babu fare da ake sarrafawa",
    stake: "Adadin fare",
    expectedProfit: "Ribar da ake tsammani",
    betId: "Lambar fare",
    bettingTime: "Lokacin yin fare",
    cancel: "Soke",
    cancelBet: "Ka tabbata kana son soke wannan fare?",
    cancelSuccess: "An soke fare cikin nasara",
    cancelError: "An kasa soke fare",
    loading: "Ana lodawa...",
    error: "An samu kuskure",
    success: "Nasara",
    failed: "An kasa",
    save: "Ajiye",
    close: "Rufe",
    back: "Koma baya",
    confirm: "Tabbatar",
    totalOdds: "Jimillar odds",
    potentialWin: "Ribar da za a iya samu",
    status: "Matsayi",
    pending: "Ana jira",
    won: "An ci",
    lost: "An sha kashi",
    cancelled: "An soke",
    processing: "Ana sarrafawa"
  },

  yo: {
    noProcessingBets: "Kò sí tẹtí tí ń ṣiṣẹ́ lọ́wọ́",
    stake: "Iye tẹtí",
    expectedProfit: "Èrè tí a retí",
    betId: "Nọ́mbà tẹtí",
    bettingTime: "Àkókò tẹtí",
    cancel: "Fagilé",
    cancelBet: "Ṣé o dá ọ lójú pé o fẹ́ fagilé tẹtí yìí?",
    cancelSuccess: "A fagilé tẹtí náà dáadáa",
    cancelError: "A kò lè fagilé tẹtí náà",
    loading: "Ó ń ṣí...",
    error: "Àṣìṣe kan ṣẹlẹ̀",
    success: "Àṣeyọrí",
    failed: "Kò yọrí sí rere",
    save: "Fi pamọ́",
    close: "Pade",
    back: "Padà",
    confirm: "Jẹ́rìí",
    totalOdds: "Àpapọ̀ odds",
    potentialWin: "Èrè tó ṣeé rí",
    status: "Ipò",
    pending: "Ń dúró",
    won: "Ti ṣẹ́gun",
    lost: "Ti pàdánù",
    cancelled: "Ti fagilé",
    processing: "Ń ṣiṣẹ́"
  },

  zu: {
    noProcessingBets: "Awekho amabhethi asacutshungulwayo",
    stake: "Imali yokubheja",
    expectedProfit: "Inzuzo elindelekile",
    betId: "I-ID yokubheja",
    bettingTime: "Isikhathi sokubheja",
    cancel: "Khansela",
    cancelBet: "Uyaqiniseka ukuthi ufuna ukukhansela lokhu kubheja?",
    cancelSuccess: "Ukubheja kukhanseliwe ngempumelelo",
    cancelError: "Yehlulekile ukukhansela ukubheja",
    loading: "Iyalayisha...",
    error: "Kuvele iphutha",
    success: "Kuphumelele",
    failed: "Kwehlulekile",
    save: "Londoloza",
    close: "Vala",
    back: "Emuva",
    confirm: "Qinisekisa",
    totalOdds: "Ama-odds esewonke",
    potentialWin: "Ukuwina okungase kwenzeke",
    status: "Isimo",
    pending: "Kulindile",
    won: "Kunqobile",
    lost: "Kulahlekile",
    cancelled: "Kukhanseliwe",
    processing: "Kuyacutshungulwa"
  },

  am: {
    noProcessingBets: "በሂደት ላይ ያሉ ውርርዶች የሉም",
    stake: "የውርርድ መጠን",
    expectedProfit: "የሚጠበቀው ትርፍ",
    betId: "የውርርድ መለያ",
    bettingTime: "የውርርድ ሰዓት",
    cancel: "ሰርዝ",
    cancelBet: "ይህን ውርርድ ለመሰረዝ እርግጠኛ ነዎት?",
    cancelSuccess: "ውርርዱ በተሳካ ሁኔታ ተሰርዟል",
    cancelError: "ውርርዱን መሰረዝ አልተቻለም",
    loading: "በመጫን ላይ...",
    error: "ስህተት ተፈጥሯል",
    success: "ተሳክቷል",
    failed: "አልተሳካም",
    save: "አስቀምጥ",
    close: "ዝጋ",
    back: "ተመለስ",
    confirm: "አረጋግጥ",
    totalOdds: "ጠቅላላ ዕድል",
    potentialWin: "ሊገኝ የሚችል ድል",
    status: "ሁኔታ",
    pending: "በመጠባበቅ ላይ",
    won: "አሸንፏል",
    lost: "ተሸንፏል",
    cancelled: "ተሰርዟል",
    processing: "በሂደት ላይ"
  },

  so: {
    noProcessingBets: "Ma jiraan sharad la farsamaynayo",
    stake: "Lacagta sharadka",
    expectedProfit: "Faa'iidada la filayo",
    betId: "Aqoonsiga sharadka",
    bettingTime: "Waqtiga sharadka",
    cancel: "Jooji",
    cancelBet: "Ma hubtaa inaad rabto inaad joojiso shadarkan?",
    cancelSuccess: "Shadarka si guul leh ayaa loo joojiyay",
    cancelError: "Shadarka lama joojin karin",
    loading: "Waa la soo rarayaa...",
    error: "Khalad ayaa dhacay",
    success: "Guul",
    failed: "Wuu fashilmay",
    save: "Kaydi",
    close: "Xir",
    back: "Dib u noqo",
    confirm: "Xaqiiji",
    totalOdds: "Wadarta odds",
    potentialWin: "Guusha suurtagalka ah",
    status: "Xaalad",
    pending: "Sugaya",
    won: "Guulaystay",
    lost: "Guuldarraystay",
    cancelled: "La joojiyay",
    processing: "La farsamaynayo"
  },

  rw: {
    noProcessingBets: "Nta mahitamo ari gutunganywa",
    stake: "Amafaranga yashyizweho",
    expectedProfit: "Inyungu iteganyijwe",
    betId: "Nomero y'ihitamo",
    bettingTime: "Igihe cyo gutega",
    cancel: "Hagarika",
    cancelBet: "Urashaka koko guhagarika iri hitamo?",
    cancelSuccess: "Ihitamo ryahagaritswe neza",
    cancelError: "Ntibyashobotse guhagarika ihitamo",
    loading: "Birimo gutegurwa...",
    error: "Habaye ikosa",
    success: "Byagenze neza",
    failed: "Byanze",
    save: "Bika",
    close: "Funga",
    back: "Subira inyuma",
    confirm: "Emeza",
    totalOdds: "Odds zose",
    potentialWin: "Icyo ushobora gutsindira",
    status: "Imiterere",
    pending: "Birategerejwe",
    won: "Yatsinze",
    lost: "Yatsinzwe",
    cancelled: "Byahagaritswe",
    processing: "Birimo gutunganywa"
  },

  lg: {
    noProcessingBets: "Tewali zza bbe ezikyakolebwako",
    stake: "Ssente eziteereddwa",
    expectedProfit: "Amagoba agasuubirwa",
    betId: "Namba ya bbe",
    bettingTime: "Ekiseera eky'okuteeba",
    cancel: "Sazaamu",
    cancelBet: "Okakasa nti oyagala okusazaamu bbe eno?",
    cancelSuccess: "Bbe esaziddwamu bulungi",
    cancelError: "Tekisobose kusazaamu bbe",
    loading: "Kitikka...",
    error: "Wabaddewo ensobi",
    success: "Kiwedde bulungi",
    failed: "Kigaanye",
    save: "Tereka",
    close: "Ggalawo",
    back: "Ddayo",
    confirm: "Kakasa",
    totalOdds: "Odds zonna awamu",
    potentialWin: "Ssente z'oyinza okuwangula",
    status: "Embeera",
    pending: "Kyakalindirira",
    won: "Kiwanguddwa",
    lost: "Kifiiriddwa",
    cancelled: "Kisaziddwamu",
    processing: "Kikolebwako"
  },

  af: {
    noProcessingBets: "Geen weddenskappe word verwerk nie",
    stake: "Weddenskapbedrag",
    expectedProfit: "Verwagte wins",
    betId: "Wed-ID",
    bettingTime: "Wedtyd",
    cancel: "Kanselleer",
    cancelBet: "Is jy seker jy wil hierdie weddenskap kanselleer?",
    cancelSuccess: "Weddenskap suksesvol gekanselleer",
    cancelError: "Kon nie die weddenskap kanselleer nie",
    loading: "Laai...",
    error: "Daar het 'n fout voorgekom",
    success: "Sukses",
    failed: "Misluk",
    save: "Stoor",
    close: "Maak toe",
    back: "Terug",
    confirm: "Bevestig",
    totalOdds: "Totale kans",
    potentialWin: "Moontlike wins",
    status: "Status",
    pending: "Hangende",
    won: "Gewen",
    lost: "Verloor",
    cancelled: "Gekanselleer",
    processing: "Word verwerk"
  }
};


const getBetSlipText = (language, key) =>
  LANGUAGE_TRANSLATIONS[language]?.[key] ||
  LANGUAGE_TRANSLATIONS[language?.split("-")[0]]?.[key] ||
  LANGUAGE_TRANSLATIONS.en[key] || key;

export default function Betslip() {

  const [language, setLanguage] = useState(() => {
    try {
      return localStorage.getItem("language") ||
        localStorage.getItem("appLanguage") ||
        localStorage.getItem("lang") || "en";
    } catch {
      return "en";
    }
  });

  const t = (key) => getBetSlipText(language, key);

  useEffect(() => {
    const syncLanguage = (event) => {
      const nextLanguage = event?.detail?.language ||
        (typeof event?.detail === "string" ? event.detail : "");
      if (nextLanguage) setLanguage(nextLanguage);
    };
    const syncStorage = (event) => {
      if (!event.key || ["language", "appLanguage", "lang"].includes(event.key)) {
        const nextLanguage = event.newValue ||
          localStorage.getItem("language") ||
          localStorage.getItem("appLanguage") ||
          localStorage.getItem("lang") || "en";
        setLanguage(nextLanguage);
      }
    };
    window.addEventListener("languageChanged", syncLanguage);
    window.addEventListener("storage", syncStorage);
    return () => {
      window.removeEventListener("languageChanged", syncLanguage);
      window.removeEventListener("storage", syncStorage);
    };
  }, []);

  // ==========================================================
  // STATES
  // ==========================================================

  const [bets, setBets] = useState([]);

  const [loading, setLoading] =
    useState(true);

  const [userStatus, setUserStatus] =
    useState("");

  const [userKO, setUserKO] =
    useState("NO");

  // Prevent double cancel
  const [cancellingIds, setCancellingIds] =
    useState({});

  // Balance context
  const { setBalances } =
    useBalance();

  // ==========================================================
  // SHADOW DOM
  // ==========================================================

  const shadowHostRef =
    useRef(null);

  const [shadowRoot, setShadowRoot] =
    useState(null);

  // ==========================================================
  // FIRESTORE BALANCE FIELDS
  // ==========================================================

  const fieldMap = {
    TZS: "tshBalance",
    USDT: "usdtBalance",
    KES: "KESBalance",
    UGX: "UGXBalance",
    RWF: "RWFBalance",
    BIF: "BIFBalance",
    ZMW: "ZMWBalance",
    MWK: "MWKBalance",
    MZN: "MZNBalance",
    USD: "USDBalance",
    SSP: "SSPBalance",
    BWP: "BWPBalance",
    MGA: "MGABalance",
  };

  // ==========================================================
  // CREATE SHADOW ROOT
  // ==========================================================

  useEffect(() => {

    if (!shadowHostRef.current) {
      return;
    }

    if (
      shadowHostRef.current.shadowRoot
    ) {

      setShadowRoot(
        shadowHostRef.current.shadowRoot
      );

      return;
    }

    const root =
      shadowHostRef.current.attachShadow({
        mode: "open",
      });

    setShadowRoot(root);

  }, []);

  // ==========================================================
  // LOAD DATA
  // ==========================================================

  const loadData = async () => {

    try {

      setLoading(true);

      const username =
        localStorage.getItem(
          "username"
        );

      // ======================================================
      // USERNAME CHECK
      // ======================================================

      if (!username) {

        console.error(
          "Username haipo localStorage"
        );

        setBets([]);

        return;
      }

      // ======================================================
      // LOAD USER
      // ======================================================

      const userQuery =
        query(
          collection(
            db,
            "users"
          ),
          where(
            "username",
            "==",
            username
          )
        );

      const userSnap =
        await getDocs(
          userQuery
        );

      if (
        !userSnap.empty
      ) {

        const userData =
          userSnap.docs[0].data();

        setUserStatus(
          userData.status || ""
        );

        setUserKO(
          userData.KO || "NO"
        );

        // ====================================================
        // SYNC BALANCES
        // ====================================================

        const balances = {};

        Object.entries(
          fieldMap
        ).forEach(
          ([currency, field]) => {

            balances[currency] =
              Number(
                userData[field] || 0
              );

          }
        );

        if (
          typeof setBalances ===
          "function"
        ) {

          setBalances(
            (previous) => ({
              ...(previous || {}),
              ...balances,
            })
          );

        }

      }

      // ======================================================
      // LOAD ANTSCORE
      // ======================================================

      const antSnap =
        await getDocs(
          collection(
            db,
            "antscore"
          )
        );

      // ======================================================
      // LOAD CORRECT SCORE
      // ======================================================

      const correctSnap =
        await getDocs(
          collection(
            db,
            "correctscore"
          )
        );

      // ======================================================
      // FILTER ANTSCORE
      // ======================================================

      const antData =
        antSnap.docs
          .map(
            (firebaseDoc) => ({
              id:
                firebaseDoc.id,

              betCollection:
                "antscore",

              ...firebaseDoc.data(),
            })
          )
          .filter(
            (bet) =>
              bet.username ===
                username &&
              !bet.result
          );

      // ======================================================
      // FILTER CORRECT SCORE
      // ======================================================

      const correctData =
        correctSnap.docs
          .map(
            (firebaseDoc) => ({
              id:
                firebaseDoc.id,

              betCollection:
                "correctscore",

              ...firebaseDoc.data(),
            })
          )
          .filter(
            (bet) =>
              bet.username ===
                username &&
              !bet.result
          );

      // ======================================================
      // COMBINE
      // ======================================================

      const all = [
        ...antData,
        ...correctData,
      ];

      // ======================================================
      // SORT NEWEST FIRST
      // ======================================================

      all.sort(
        (a, b) => {

          const ta =
            a.createdAt?.toDate
              ? a.createdAt.toDate()
              : new Date(
                  a.createdAt ||
                    0
                );

          const tb =
            b.createdAt?.toDate
              ? b.createdAt.toDate()
              : new Date(
                  b.createdAt ||
                    0
                );

          return tb - ta;

        }
      );

      setBets(all);

    } catch (err) {

      console.error(
        "BETSLIP LOAD ERROR:",
        err
      );

      setBets([]);

    } finally {

      setLoading(false);

    }

  };

  // ==========================================================
  // LOAD WHEN COMPONENT MOUNTS
  // ==========================================================

  useEffect(() => {

    loadData();

  }, []);

  // ==========================================================
  // CAN CANCEL
  // 15 MINUTES
  // ==========================================================

  const canCancel = (
    bet
  ) => {

    if (
      !bet.createdAt ||
      bet.result
    ) {
      return false;
    }

    const created =
      bet.createdAt.toDate
        ? bet.createdAt.toDate()
        : new Date(
            bet.createdAt
          );

    const elapsed =
      new Date() -
      created;

    return (
      elapsed <=
      15 * 60 * 1000
    );

  };

  // ==========================================================
  // FORMAT BETTING TIME
  // ==========================================================

  const formatCreatedAt = (
    bet
  ) => {

    if (
      !bet.createdAt
    ) {
      return "-";
    }

    const date =
      bet.createdAt.toDate
        ? bet.createdAt.toDate()
        : new Date(
            bet.createdAt
          );

    const localeMap = { sw: "sw-TZ", fr: "fr-FR", pt: "pt-PT", es: "es-ES", de: "de-DE", ar: "ar", zh: "zh-CN" };

    return date.toLocaleString(
      localeMap[language] || "en-GB",
      {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }
    );

  };

  // ==========================================================
  // BET ID
  // ==========================================================

  const getBetId = (
    bet
  ) => {

    if (
      bet.betId
    ) {

      return bet.betId;

    }

    return (
      bet.id?.slice(
        0,
        20
      ) ||
      "--------------------"
    );

  };

  // ==========================================================
  // CANCEL BET
  // ==========================================================

  const handleCancel = async (
    bet
  ) => {

    // ========================================================
    // KO USER CANNOT CANCEL
    // ========================================================

    if (
      userKO === "YES"
    ) {

      alert(
        t("cancelNotAllowed")
      );

      return;
    }

    // ========================================================
    // PREVENT DOUBLE CLICK
    // ========================================================

    if (
      cancellingIds[
        bet.id
      ]
    ) {

      return;
    }

    // ========================================================
    // CHECK 15 MINUTES
    // ========================================================

    if (
      !canCancel(bet)
    ) {

      alert(
        t("cancelExpired")
      );

      return;
    }

    // ========================================================
    // CONFIRM
    // ========================================================

    const ok =
      window.confirm(
        t("confirmCancel")
      );

    if (!ok) {
      return;
    }

    // ========================================================
    // LOCK BUTTON
    // ========================================================

    setCancellingIds(
      (previous) => ({
        ...previous,

        [bet.id]: true,
      })
    );

    try {

      // ======================================================
      // USERNAME
      // ======================================================

      const username =
        localStorage.getItem(
          "username"
        );

      if (!username) {

        throw new Error(
          t("usernameMissing")
        );

      }

      // ======================================================
      // CURRENCY FIELD
      // ======================================================

      const field =
        fieldMap[
          bet.currency
        ];

      if (!field) {

        throw new Error(
          t("unknownCurrency")
        );

      }

      // ======================================================
      // FIND USER
      // ======================================================

      const q =
        query(
          collection(
            db,
            "users"
          ),
          where(
            "username",
            "==",
            username
          )
        );

      const userQuery =
        await getDocs(q);

      if (
        userQuery.empty
      ) {

        throw new Error(
          t("userNotFound")
        );

      }

      const userDoc =
        userQuery.docs[0];

      const userRef =
        doc(
          db,
          "users",
          userDoc.id
        );

      // ======================================================
      // BET REFERENCE
      // ======================================================

      const betRef =
        doc(
          db,
          bet.betCollection,
          bet.id
        );

      // ======================================================
      // TRANSACTION
      // ======================================================

      await runTransaction(
        db,
        async (
          transaction
        ) => {

          const betSnap =
            await transaction.get(
              betRef
            );

          // ================================================
          // BET DOES NOT EXIST
          // ================================================

          if (
            !betSnap.exists()
          ) {

            throw new Error(
              t("betNotFound")
            );

          }

          const betData =
            betSnap.data();

          // ================================================
          // ALREADY PROCESSED
          // ================================================

          if (
            betData.result
          ) {

            throw new Error(
              t("betProcessed")
            );

          }

          // ================================================
          // CHECK CANCELLATION TIME
          // ================================================

          if (
            betData.createdAt
          ) {

            const created =
              betData.createdAt.toDate
                ? betData.createdAt.toDate()
                : new Date(
                    betData.createdAt
                  );

            const elapsed =
              new Date() -
              created;

            if (
              elapsed >
              15 * 60 * 1000
            ) {

              throw new Error(
                t("cancelExpired")
              );

            }

          }

          // ================================================
          // MARK CANCELLED
          // ================================================

          transaction.update(
            betRef,
            {
              result:
                "cancelled",

              cancelledAt:
                new Date(),
            }
          );

        }
      );

      // ======================================================
      // RETURN STAKE
      // ======================================================

      await updateDoc(
        userRef,
        {
          [field]:
            increment(
              Number(
                bet.amount ||
                  0
              )
            ),
        }
      );

      // ======================================================
      // UPDATE BALANCE CONTEXT
      // ======================================================

      if (
        typeof setBalances ===
        "function"
      ) {

        setBalances(
          (previous) => {

            const oldBalance =
              Number(
                previous?.[
                  bet.currency
                ] || 0
              );

            const returnedAmount =
              Number(
                bet.amount ||
                  0
              );

            const newBalance =
              oldBalance +
              returnedAmount;

            return {
              ...(previous || {}),

              [bet.currency]:
                newBalance,

              [field]:
                newBalance,
            };

          }
        );

      }

      // ======================================================
      // REMOVE FROM CURRENT UI
      // ======================================================

      setBets(
        (previous) =>
          previous.filter(
            (item) =>
              item.id !==
              bet.id
          )
      );

    } catch (err) {

      console.error(
        "CANCEL BET ERROR:",
        err
      );

      alert(
        err?.message ||
          t("cancelError")
      );

    } finally {

      setCancellingIds(
        (previous) => ({
          ...previous,

          [bet.id]:
            false,
        })
      );

    }

  };

  // ==========================================================
  // CONTENT
  // ==========================================================

  const content = (

    <div className="mybets-isolated">

      {/* ====================================================
          LOADING
      ==================================================== */}

      {loading ? (

        <div className="loading-dots">

          <span></span>

          <span></span>

          <span></span>

        </div>

      ) : bets.length === 0 ? (

        /* ==================================================
           NO BETS
        ================================================== */

        <div className="no-bets">

          {t("noBets")}

        </div>

      ) : (

        /* ==================================================
           BETS
        ================================================== */

        bets.map(
          (bet) => (

            <div
              className="betslip-card"
              key={
                `${bet.betCollection}-${bet.id}`
              }
            >

              {/* ==========================================
                  TOP SUMMARY
              ========================================== */}

              <div className="betslip-summary">

                {/* STAKE */}

                <div className="summary-item">

                  <span>
                    {t("stake")}
                  </span>

                  <strong>
                    {bet.currency}{" "}
                    {Number(
                      bet.amount ||
                        0
                    ).toLocaleString()}
                  </strong>

                </div>

                {/* EXPECTED PROFIT */}

                <div className="summary-item">

                  <span>
                    {t("expectedProfit")}
                  </span>

                  <strong className="profit">

                    {(
                      Number(
                        bet.amount ||
                          0
                      ) +
                      Number(
                        bet.profit ||
                          0
                      )
                    ).toLocaleString()}

                  </strong>

                </div>

              </div>

              {/* ==========================================
                  MATCH
              ========================================== */}

              <div className="betslip-match">

                {/* MATCH HEADER */}

                <div className="match-header">

                  <span>

                    {bet.matchDate ||
                      "-"}{" "}

                    {bet.matchTime ||
                      ""}

                  </span>

                  <span>

                    {bet.league ||
                      "League"}

                  </span>

                </div>

                {/* TEAMS */}

                <div className="teams">

                  {/* TEAM A */}

                  <div className="team">

                    <strong>
                      {bet.teamA ||
                        "-"}
                    </strong>

                  </div>

                  {/* VS */}

                  <div className="vs">
                    VS
                  </div>

                  {/* TEAM B */}

                  <div className="team">

                    <strong>
                      {bet.teamB ||
                        "-"}
                    </strong>

                  </div>

                </div>

                {/* PICK */}

                <div className="pick">

                  <span>

                    {bet.prediction ||
                      bet.mode ||
                      "Pick"}

                  </span>

                  <span className="score">

                    [
                    {bet.score ||
                      "-"}

                    ]

                  </span>

                  <span className="odds">

                    @
                    {Number(
                      bet.odds ||
                        0
                    )}%

                  </span>

                </div>

              </div>

              {/* ==========================================
                  TICKET ROW
              ========================================== */}

              <div className="ticket-row">

                <div className="ticket-left">

                  <span>
                    {t("betId")}
                  </span>

                  <strong>
                    {getBetId(bet)}
                  </strong>

                </div>

                {/* CANCEL */}

                {canCancel(bet) &&
                  userKO !==
                    "YES" && (

                    <button
                      type="button"
                      className="cancel-ticket"
                      onClick={() =>
                        handleCancel(
                          bet
                        )
                      }
                      disabled={
                        cancellingIds[
                          bet.id
                        ]
                      }
                    >

                      {cancellingIds[
                        bet.id
                      ]
                        ? "..."
                        : "CANCEL"}

                    </button>

                  )}

              </div>

              {/* ==========================================
                  BETTING TIME
              ========================================== */}

              <div className="bet-time">

                <span>
                  {t("bettingTime")}
                </span>

                <strong>
                  {formatCreatedAt(
                    bet
                  )}
                </strong>

              </div>

              {/* ==========================================
                  BOTTOM SUMMARY
              ========================================== */}

              <div className="bottom-summary">

                {/* STAKE */}

                <div className="summary-row">

                  <span>
                    {t("stake")}
                  </span>

                  <strong>

                    {bet.currency}{" "}

                    {Number(
                      bet.amount ||
                        0
                    ).toLocaleString()}

                  </strong>

                </div>

                {/* EXPECTED PROFIT */}

                <div className="summary-row">

                  <span>
                    {t("expectedProfit")}
                  </span>

                  <strong className="profit">

                    {(
                      Number(
                        bet.amount ||
                          0
                      ) +
                      Number(
                        bet.profit ||
                          0
                      )
                    ).toLocaleString()}

                  </strong>

                </div>

              </div>

            </div>

          )
        )

      )}

    </div>

  );

  // ==========================================================
  // SHADOW DOM RENDER
  // ==========================================================

  return (

    <div
      ref={shadowHostRef}
      className="mybets-shadow-host"
    >

      {shadowRoot &&
        createPortal(

          <>

            {/* =============================================
                ALL CSS IS INSIDE SHADOW DOM
            ============================================= */}

            <style>
              {BETSLIP_CSS}
            </style>

            {content}

          </>,

          shadowRoot

        )}

    </div>

  );

}


// ============================================================
// BETSLIP CSS
//
// IMPORTANT:
//
// Hii CSS ipo ndani ya Shadow DOM.
//
// CSS ya nje kama:
//
// *
// body
// body div
// button
// img
// .mybets-isolated
//
// haiwezi ku-style elements za ndani.
// ============================================================

const BETSLIP_CSS = `

/* =========================================================
   SHADOW HOST
========================================================= */

:host {

    display: block;

    width: 100%;

    min-width: 0;

    max-width: 100%;

    margin: 0;

    padding: 0;

    box-sizing: border-box;

}


/* =========================================================
   ROOT
========================================================= */

.mybets-isolated {

    all: initial;

    display: block;

    position: relative;

    width: 100%;

    min-width: 0;

    max-width: 100%;

    min-height: 100vh;

    margin: 0;

    padding: 12px;

    box-sizing: border-box;

    overflow-x: hidden;

    isolation: isolate;

    background: #ffffff;

    color: #111827;

    font-family:
        Arial,
        Helvetica,
        sans-serif;

    font-size: 16px;

    line-height: 1.3;

    -webkit-text-size-adjust: 100%;

    text-size-adjust: 100%;

}


/* =========================================================
   BOX SIZING
========================================================= */

.mybets-isolated,
.mybets-isolated *,
.mybets-isolated *::before,
.mybets-isolated *::after {

    box-sizing: border-box;

}


/* =========================================================
   RESET
========================================================= */

.mybets-isolated h1,
.mybets-isolated h2,
.mybets-isolated h3,
.mybets-isolated h4,
.mybets-isolated h5,
.mybets-isolated h6,
.mybets-isolated p,
.mybets-isolated span,
.mybets-isolated div,
.mybets-isolated section,
.mybets-isolated article,
.mybets-isolated header,
.mybets-isolated footer,
.mybets-isolated main,
.mybets-isolated button,
.mybets-isolated input,
.mybets-isolated select,
.mybets-isolated textarea,
.mybets-isolated img,
.mybets-isolated strong,
.mybets-isolated small {

    margin: 0;

    padding: 0;

    box-sizing: border-box;

    font-family: inherit;

}


/* =========================================================
   BUTTON
========================================================= */

.mybets-isolated button {

    appearance: none;

    -webkit-appearance: none;

    display: inline-block;

    border: 0;

    outline: none;

    margin: 0;

    padding: 0;

    background: none;

    color: inherit;

    font-family: inherit;

    font-size: inherit;

    line-height: normal;

    text-transform: none;

    text-decoration: none;

    letter-spacing: normal;

    cursor: pointer;

    -webkit-tap-highlight-color: transparent;

}


/* =========================================================
   BUTTON FOCUS
========================================================= */

.mybets-isolated button:focus {

    outline: none;

}


/* =========================================================
   BUTTON FOCUS VISIBLE
========================================================= */

.mybets-isolated
button:focus-visible {

    outline:
        3px solid
        rgba(
            30,
            136,
            229,
            .35
        );

    outline-offset: 2px;

}


/* =========================================================
   INPUT
========================================================= */

.mybets-isolated input,
.mybets-isolated select,
.mybets-isolated textarea {

    box-sizing: border-box;

    font-family: inherit;

    font-size: inherit;

    color: inherit;

}


/* =========================================================
   IMAGE
========================================================= */

.mybets-isolated img {

    display: block;

    max-width: 100%;

    height: auto;

    box-sizing: border-box;

}


/* =========================================================
   NO BETS
========================================================= */

.mybets-isolated .no-bets {

    display: flex;

    justify-content: center;

    align-items: center;

    width: 100%;

    min-height: 220px;

    padding: 30px;

    color: #666666;

    font-size: 17px;

    font-weight: 600;

    line-height: 1.4;

    text-align: center;

}


/* =========================================================
   CARD
========================================================= */

.mybets-isolated .betslip-card {

    position: relative;

    width: 100%;

    max-width: 100%;

    margin:
        0 0 18px 0;

    padding: 0;

    overflow: hidden;

    background: #f5f2f2;

    border:
        1px solid #dcdcdc;

    border-radius: 12px;

    box-shadow:
        0 2px 6px
        rgba(
            0,
            0,
            0,
            .12
        );

    isolation: isolate;

}


/* =========================================================
   TOP SUMMARY
========================================================= */

.mybets-isolated .betslip-summary {

    display: grid;

    grid-template-columns:
        1fr 1fr;

    width: 100%;

    margin: 0;

    padding: 0;

    background: #f8ecd3;

}


/* =========================================================
   SUMMARY ITEM
========================================================= */

.mybets-isolated .summary-item {

    min-width: 0;

    margin: 0;

    padding: 15px;

    text-align: center;

}


/* =========================================================
   SUMMARY BORDER
========================================================= */

.mybets-isolated
.summary-item:first-child {

    border-right:
        1px solid #e4d7ba;

}


/* =========================================================
   SUMMARY LABEL
========================================================= */

.mybets-isolated
.summary-item span {

    display: block;

    margin:
        0 0 6px 0;

    padding: 0;

    color: #666666;

    font-size: 14px;

    line-height: 1.3;

    font-weight: 400;

}


/* =========================================================
   SUMMARY VALUE
========================================================= */

.mybets-isolated
.summary-item strong {

    display: block;

    margin: 0;

    padding: 0;

    color: #0b82ca;

    font-size: 23px;

    line-height: 1.2;

    font-weight: 700;

}


/* =========================================================
   PROFIT
========================================================= */

.mybets-isolated
.summary-item .profit {

    color: #2ba84a;

}


/* =========================================================
   MATCH
========================================================= */

.mybets-isolated .betslip-match {

    width: 100%;

    margin: 0;

    padding: 18px;

    text-align: center;

}


/* =========================================================
   MATCH HEADER
========================================================= */

.mybets-isolated .match-header {

    display: flex;

    justify-content: center;

    align-items: center;

    flex-wrap: wrap;

    gap: 12px;

    width: 100%;

    margin:
        0 0 18px 0;

    padding: 0;

    color: #555555;

    font-size: 15px;

    line-height: 1.4;

    font-weight: 600;

}


/* =========================================================
   TEAMS
========================================================= */

.mybets-isolated .teams {

    display: flex;

    justify-content: space-between;

    align-items: center;

    width: 100%;

    min-width: 0;

    gap: 15px;

    margin: 0;

    padding: 0;

}


/* =========================================================
   TEAM
========================================================= */

.mybets-isolated .team {

    flex:
        1 1 0;

    min-width: 0;

    margin: 0;

    padding: 0;

    text-align: center;

}


/* =========================================================
   TEAM NAME
========================================================= */

.mybets-isolated .team strong {

    display: block;

    margin:
        8px 0 0 0;

    padding: 0;

    color: #111111;

    font-size: 20px;

    line-height: 1.25;

    font-weight: 700;

    overflow-wrap: anywhere;

}


/* =========================================================
   VS
========================================================= */

.mybets-isolated .vs {

    flex:
        0 0 auto;

    margin: 0;

    padding: 0;

    color: #3488c0;

    font-size: 30px;

    line-height: 1;

    font-weight: 700;

}


/* =========================================================
   PICK
========================================================= */

.mybets-isolated .pick {

    display: flex;

    justify-content: center;

    align-items: center;

    flex-wrap: wrap;

    gap: 14px;

    width: 100%;

    margin:
        18px 0 0 0;

    padding: 10px;

    background: #e6e3e3;

    color: #1c1b1b;

    font-size: 20px;

    line-height: 1.3;

    font-weight: 700;

}


/* =========================================================
   SCORE
========================================================= */

.mybets-isolated .score {

    margin: 0;

    padding: 0;

    color: #1d7fe2;

    font-size: 24px;

    line-height: 1.2;

    font-weight: 700;

}


/* =========================================================
   ODDS
========================================================= */

.mybets-isolated .odds {

    margin: 0;

    padding: 0;

    color: #b78400;

    font-size: 22px;

    line-height: 1.2;

    font-weight: 700;

}


/* =========================================================
   TICKET ROW
========================================================= */

.mybets-isolated .ticket-row {

    display: flex;

    justify-content:
        space-between;

    align-items: center;

    width: 100%;

    min-width: 0;

    gap: 15px;

    margin: 0;

    padding:
        14px 16px;

    background: #ffffff;

    border-top:
        1px solid #ececec;

    border-bottom:
        1px solid #ececec;

}


/* =========================================================
   TICKET LEFT
========================================================= */

.mybets-isolated .ticket-left {

    flex:
        1 1 auto;

    min-width: 0;

    margin: 0;

    padding: 0;

    overflow: hidden;

}


/* =========================================================
   BET ID LABEL
========================================================= */

.mybets-isolated
.ticket-left span {

    display: block;

    margin:
        0 0 4px 0;

    padding: 0;

    color: #666666;

    font-size: 13px;

    line-height: 1.2;

    font-weight: 400;

}


/* =========================================================
   BET ID
========================================================= */

.mybets-isolated
.ticket-left strong {

    display: block;

    margin: 0;

    padding: 0;

    color: #222222;

    font-size: 15px;

    line-height: 1.3;

    font-weight: 700;

    overflow-wrap: anywhere;

    word-break: break-word;

}


/* =========================================================
   CANCEL BUTTON
========================================================= */

.mybets-isolated
.cancel-ticket {

    flex:
        0 0 auto;

    width: auto;

    min-width: 120px;

    height: 42px;

    margin: 0;

    padding:
        0 18px;

    border: 0;

    border-radius: 8px;

    background: #ff4d4d;

    color: #ffffff;

    font-family: inherit;

    font-size: 15px;

    line-height: 1;

    font-weight: 700;

    cursor: pointer;

    transition:
        background .2s ease,
        opacity .2s ease,
        transform .15s ease;

}


/* =========================================================
   CANCEL HOVER
========================================================= */

.mybets-isolated
.cancel-ticket:hover {

    background: #e53b3b;

}


/* =========================================================
   CANCEL ACTIVE
========================================================= */

.mybets-isolated
.cancel-ticket:active {

    transform:
        scale(.97);

}


/* =========================================================
   CANCEL DISABLED
========================================================= */

.mybets-isolated
.cancel-ticket:disabled {

    opacity: .7;

    cursor: not-allowed;

}


/* =========================================================
   BET TIME
========================================================= */

.mybets-isolated .bet-time {

    display: flex;

    justify-content:
        space-between;

    align-items: center;

    flex-wrap: wrap;

    width: 100%;

    gap: 10px;

    margin: 0;

    padding:
        15px 18px;

    background: #fafafa;

    border-bottom:
        1px solid #ececec;

    color: #555555;

    font-size: 15px;

    line-height: 1.3;

}


/* =========================================================
   BET TIME VALUE
========================================================= */

.mybets-isolated
.bet-time strong {

    margin: 0;

    padding: 0;

    color: #b8860b;

    font-weight: 700;

}


/* =========================================================
   BOTTOM SUMMARY
========================================================= */

.mybets-isolated
.bottom-summary {

    width: 100%;

    margin: 0;

    padding: 0;

    background: #eef9fc;

    border-top:
        1px solid #d8e8ee;

}


/* =========================================================
   SUMMARY ROW
========================================================= */

.mybets-isolated
.summary-row {

    display: flex;

    justify-content:
        space-between;

    align-items: center;

    width: 100%;

    gap: 15px;

    margin: 0;

    padding:
        14px 18px;

}


/* =========================================================
   SUMMARY ROW BORDER
========================================================= */

.mybets-isolated
.summary-row:first-child {

    border-bottom:
        1px solid #d8e8ee;

}


/* =========================================================
   SUMMARY ROW LABEL
========================================================= */

.mybets-isolated
.summary-row span {

    margin: 0;

    padding: 0;

    color: #2d6d9a;

    font-size: 18px;

    line-height: 1.3;

    font-weight: 700;

}


/* =========================================================
   SUMMARY ROW VALUE
========================================================= */

.mybets-isolated
.summary-row strong {

    margin: 0;

    padding: 0;

    color: #2d6d9a;

    font-size: 20px;

    line-height: 1.3;

    font-weight: 700;

    text-align: right;

}


/* =========================================================
   SUMMARY PROFIT
========================================================= */

.mybets-isolated
.summary-row .profit {

    color: #2ea44f;

}


/* =========================================================
   LOADING DOTS
========================================================= */

.mybets-isolated .loading-dots {

    display: flex;

    justify-content: center;

    align-items: center;

    gap: 10px;

    width: 100%;

    min-height: 220px;

    margin: 0;

    padding: 0;

}


/* =========================================================
   LOADING DOT
========================================================= */

.mybets-isolated
.loading-dots span {

    display: block;

    width: 12px;

    height: 12px;

    margin: 0;

    padding: 0;

    border-radius: 50%;

    background: #1e88e5;

    animation:
        mybetsIsolatedDotBounce
        1.2s infinite
        ease-in-out;

}


/* =========================================================
   DOT 2
========================================================= */

.mybets-isolated
.loading-dots span:nth-child(2) {

    animation-delay:
        .2s;

}


/* =========================================================
   DOT 3
========================================================= */

.mybets-isolated
.loading-dots span:nth-child(3) {

    animation-delay:
        .4s;

}


/* =========================================================
   UNIQUE DOT ANIMATION
========================================================= */

@keyframes
mybetsIsolatedDotBounce {

    0%,
    80%,
    100% {

        transform:
            scale(.5);

        opacity: .4;

    }

    40% {

        transform:
            scale(1.3);

        opacity: 1;

    }

}


/* =========================================================
   MOBILE
========================================================= */

@media (max-width: 600px) {

    .mybets-isolated {

        padding: 10px;

    }

    .mybets-isolated
    .betslip-card {

        border-radius: 10px;

        margin-bottom: 14px;

    }

    .mybets-isolated
    .summary-item {

        padding:
            13px 8px;

    }

    .mybets-isolated
    .summary-item span {

        font-size: 12px;

    }

    .mybets-isolated
    .summary-item strong {

        font-size: 18px;

    }

    .mybets-isolated
    .betslip-match {

        padding:
            15px 10px;

    }

    .mybets-isolated
    .match-header {

        gap: 8px;

        margin-bottom:
            15px;

        font-size: 13px;

    }

    .mybets-isolated
    .teams {

        gap: 8px;

    }

    .mybets-isolated
    .team strong {

        margin-top: 6px;

        font-size: 17px;

    }

    .mybets-isolated
    .vs {

        font-size: 22px;

    }

    .mybets-isolated
    .pick {

        gap: 10px;

        margin-top:
            14px;

        padding:
            9px 7px;

        font-size: 17px;

    }

    .mybets-isolated
    .score {

        font-size: 20px;

    }

    .mybets-isolated
    .odds {

        font-size: 18px;

    }

    .mybets-isolated
    .ticket-row {

        gap: 10px;

        padding: 12px;

    }

    .mybets-isolated
    .ticket-left span {

        font-size: 11px;

    }

    .mybets-isolated
    .ticket-left strong {

        font-size: 13px;

        white-space: nowrap;

        overflow: hidden;

        text-overflow: ellipsis;

    }

    .mybets-isolated
    .cancel-ticket {

        min-width: 100px;

        height: 38px;

        padding:
            0 12px;

        font-size: 13px;

    }

    .mybets-isolated
    .bet-time {

        padding: 12px;

        font-size: 12px;

    }

    .mybets-isolated
    .summary-row {

        gap: 10px;

        padding: 12px;

    }

    .mybets-isolated
    .summary-row span {

        font-size: 15px;

    }

    .mybets-isolated
    .summary-row strong {

        font-size: 17px;

    }

}


/* =========================================================
   SMALL PHONE
========================================================= */

@media (max-width: 380px) {

    .mybets-isolated {

        padding: 7px;

    }

    .mybets-isolated
    .betslip-match {

        padding:
            13px 7px;

    }

    .mybets-isolated
    .team strong {

        font-size: 14px;

    }

    .mybets-isolated
    .vs {

        font-size: 19px;

    }

    .mybets-isolated
    .pick {

        font-size: 15px;

    }

    .mybets-isolated
    .score {

        font-size: 18px;

    }

    .mybets-isolated
    .odds {

        font-size: 16px;

    }

    .mybets-isolated
    .cancel-ticket {

        min-width: 88px;

        padding:
            0 9px;

        font-size: 12px;

    }

}


/* =========================================================
   VERY SMALL PHONE
========================================================= */

@media (max-width: 330px) {

    .mybets-isolated {

        padding: 5px;

    }

    .mybets-isolated
    .teams {

        gap: 5px;

    }

    .mybets-isolated
    .team strong {

        font-size: 13px;

    }

    .mybets-isolated
    .vs {

        font-size: 17px;

    }

    .mybets-isolated
    .ticket-row {

        padding:
            10px 8px;

    }

    .mybets-isolated
    .cancel-ticket {

        min-width: 78px;

        height: 36px;

        padding:
            0 7px;

        font-size: 11px;

    }

}


/* =========================================================
   REDUCED MOTION
========================================================= */

@media (
    prefers-reduced-motion: reduce
) {

    .mybets-isolated *,
    .mybets-isolated
    *::before,
    .mybets-isolated
    *::after {

        animation-duration:
            .01ms !important;

        animation-iteration-count:
            1 !important;

        transition-duration:
            .01ms !important;

    }

}


/* =========================================================
   BETRADE DIGITAL NEON THEME
   Matches User Commission: navy / indigo / cyan
========================================================= */

:host {
  background: #080d1b !important;
  color: #f8fafc !important;
}

.mybets-isolated {
  background:
    radial-gradient(circle at 12% 0%, rgba(99,102,241,.18), transparent 30%),
    radial-gradient(circle at 95% 15%, rgba(0,217,255,.10), transparent 26%),
    #080d1b !important;
  color: #f8fafc !important;
  font-family: Arial, Helvetica, sans-serif !important;
}

.mybets-isolated .betslip-card {
  background: linear-gradient(145deg, rgba(25,32,67,.98), rgba(10,15,31,.99)) !important;
  color: #f8fafc !important;
  border: 1px solid rgba(122,137,255,.30) !important;
  border-radius: 18px !important;
  box-shadow: 0 14px 35px rgba(0,0,0,.32), inset 0 1px 0 rgba(255,255,255,.04) !important;
}

.mybets-isolated .betslip-summary {
  background: linear-gradient(135deg, rgba(48,56,117,.96), rgba(25,32,67,.98)) !important;
  border-bottom: 1px solid rgba(99,102,241,.28) !important;
}

.mybets-isolated .summary-item:first-child {
  border-right: 1px solid rgba(125,143,255,.22) !important;
}

.mybets-isolated .summary-item span,
.mybets-isolated .match-header,
.mybets-isolated .ticket-left span,
.mybets-isolated .bet-time,
.mybets-isolated .summary-row span {
  color: #9ca8c7 !important;
}

.mybets-isolated .summary-item strong {
  color: #00d9ff !important;
  text-shadow: 0 0 16px rgba(0,217,255,.18) !important;
}

.mybets-isolated .summary-item .profit,
.mybets-isolated .summary-row .profit {
  color: #34d399 !important;
  text-shadow: 0 0 14px rgba(52,211,153,.15) !important;
}

.mybets-isolated .betslip-match {
  background: transparent !important;
  color: #f8fafc !important;
}

.mybets-isolated .team strong,
.mybets-isolated .ticket-left strong,
.mybets-isolated .summary-row strong {
  color: #f8fafc !important;
}

.mybets-isolated .vs {
  color: #00d9ff !important;
  text-shadow: 0 0 15px rgba(0,217,255,.28) !important;
}

.mybets-isolated .team-logo {
  background: #151d3a !important;
  border: 1px solid rgba(125,143,255,.35) !important;
}

.mybets-isolated .logo-fallback {
  background: linear-gradient(135deg, #6366f1, #00bfe8) !important;
  color: #ffffff !important;
}

.mybets-isolated .pick {
  background: rgba(99,102,241,.13) !important;
  color: #e0e7ff !important;
  border: 1px solid rgba(99,102,241,.30) !important;
  border-radius: 12px !important;
}

.mybets-isolated .score {
  color: #00d9ff !important;
}

.mybets-isolated .odds {
  color: #fbbf24 !important;
}

.mybets-isolated .ticket-row {
  background: rgba(255,255,255,.025) !important;
  border-top: 1px solid rgba(107,123,164,.22) !important;
  border-bottom: 1px solid rgba(107,123,164,.22) !important;
}

.mybets-isolated .cancel-ticket {
  background: linear-gradient(135deg, #ef4444, #be123c) !important;
  color: #ffffff !important;
  border: 1px solid rgba(248,113,113,.35) !important;
  border-radius: 10px !important;
  box-shadow: 0 5px 15px rgba(190,18,60,.20) !important;
}

.mybets-isolated .cancel-ticket:hover {
  background: linear-gradient(135deg, #f87171, #e11d48) !important;
}

.mybets-isolated .bet-time {
  background: rgba(99,102,241,.07) !important;
  border-bottom: 1px solid rgba(107,123,164,.22) !important;
}

.mybets-isolated .bet-time strong {
  color: #a5b4fc !important;
}

.mybets-isolated .bottom-summary {
  background: rgba(0,217,255,.055) !important;
  border-top: 1px solid rgba(0,217,255,.18) !important;
}

.mybets-isolated .summary-row {
  background: transparent !important;
}

.mybets-isolated .summary-row:first-child {
  border-bottom: 1px solid rgba(0,217,255,.14) !important;
}

.mybets-isolated .summary-row span {
  color: #9ca8c7 !important;
}

.mybets-isolated .summary-row strong {
  color: #00d9ff !important;
}

.mybets-isolated .no-bets {
  background: rgba(22,29,57,.72) !important;
  color: #aeb9dc !important;
  border: 1px dashed rgba(125,143,255,.32) !important;
  border-radius: 16px !important;
}

.mybets-isolated .loading-dots span {
  background: #00d9ff !important;
  box-shadow: 0 0 12px rgba(0,217,255,.35) !important;
}

.mybets-isolated button:focus-visible {
  outline: 3px solid rgba(0,217,255,.55) !important;
  outline-offset: 3px !important;
}

@media (prefers-reduced-motion: reduce) {
  .mybets-isolated *,
  .mybets-isolated *::before,
  .mybets-isolated *::after {
    animation-duration: .01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: .01ms !important;
  }
}

`;